import { Link } from "react-router-dom";
import { Building2, PenSquare, Compass, Calendar, Check, ArrowRight } from "lucide-react";

export default function OnboardingChecklist({ data }) {
  // data: { has_business, scores, generations_count, events_count }
  const steps = [
    {
      key: "profile",
      done: data.has_business,
      icon: Building2,
      title: "Créer votre profil business",
      detail: "Identité, adresse, fiche Google, réseaux sociaux.",
      cta: "Créer",
      to: "/dashboard/profile",
    },
    {
      key: "audit",
      done: data.has_business && data.scores?.profile_completion >= 70,
      icon: Compass,
      title: "Compléter votre profil à 70%",
      detail: "Plus votre profil est riche, plus vous êtes recommandé.",
      cta: "Compléter",
      to: "/dashboard/profile",
    },
    {
      key: "content",
      done: (data.generations_count || 0) > 0,
      icon: PenSquare,
      title: "Rédiger votre premier contenu",
      detail: "Légende Instagram, post Google, réponse à un avis…",
      cta: "Ouvrir le studio",
      to: "/dashboard/generator",
    },
    {
      key: "calendar",
      done: (data.events_count || 0) > 0,
      icon: Calendar,
      title: "Planifier votre première publication",
      detail: "Installez une cadence régulière sur vos canaux.",
      cta: "Planifier",
      to: "/dashboard/calendar",
    },
  ];
  const total = steps.length;
  const done = steps.filter(s => s.done).length;
  if (done === total) return null;
  const pct = Math.round((done / total) * 100);
  const next = steps.find(s => !s.done);

  return (
    <div className="border border-border rounded-2xl p-6 bg-gradient-to-br from-primary/5 to-violet-500/5 relative overflow-hidden" data-testid="onboarding-checklist">
      <div className="flex flex-wrap items-start justify-between gap-4 mb-5">
        <div>
          <p className="text-xs uppercase tracking-[0.25em] font-bold text-primary">Mise en route</p>
          <h2 className="text-xl font-black tracking-tight mt-1 font-display">Quatre étapes pour démarrer</h2>
        </div>
        <div className="text-right">
          <div className="text-2xl font-black font-display tabular-nums">{done}<span className="text-muted-foreground text-base">/{total}</span></div>
          <div className="w-32 h-1.5 bg-muted rounded-full overflow-hidden mt-1.5">
            <div className="h-full bg-gradient-to-r from-primary to-violet-500 rounded-full transition-all duration-700" style={{ width: `${pct}%` }} />
          </div>
        </div>
      </div>
      <ul className="space-y-2">
        {steps.map((s) => (
          <li key={s.key} className={`group flex items-center gap-3 p-3 rounded-lg border transition-all ${
            s.done ? "border-emerald-500/20 bg-emerald-500/5" :
            (next?.key === s.key ? "border-primary/40 bg-card" : "border-border bg-card")
          }`} data-testid={`step-${s.key}`}>
            <div className={`h-8 w-8 rounded-md flex items-center justify-center shrink-0 ${
              s.done ? "bg-emerald-500/15 text-emerald-500" : "bg-primary/10 text-primary"
            }`}>
              {s.done ? <Check className="h-4 w-4" /> : <s.icon className="h-4 w-4" />}
            </div>
            <div className="flex-1 min-w-0">
              <p className={`font-semibold text-sm ${s.done ? "line-through text-muted-foreground" : ""}`}>{s.title}</p>
              <p className="text-xs text-muted-foreground mt-0.5 hidden sm:block">{s.detail}</p>
            </div>
            {!s.done && (
              <Link to={s.to}>
                <button className="text-xs font-semibold text-primary hover:text-primary/80 inline-flex items-center gap-1 px-3 py-1.5 rounded-full hover:bg-primary/10 transition-colors">
                  {s.cta}<ArrowRight className="h-3 w-3 group-hover:translate-x-0.5 transition-transform" />
                </button>
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
